document.addEventListener('DOMContentLoaded', () => {
  const run = document.getElementsByClassName('component pathway');

  if (run.length > 0) {
    const toggles = document.getElementsByClassName('collapse-toggle');

    Array.from(toggles).forEach(toggle => {
      toggle.addEventListener('click', (e) => {
        e.preventDefault();
        
        const parent = toggle.parentElement.parentElement;

        const header = parent.querySelector('.header');
        const content = parent.querySelector('.content');
        const actions = parent.querySelector('.actions');

        const upArrow = parent.querySelector('.up');
        const downArrow = parent.querySelector('.down');

        const expanded = Boolean(parent.dataset.expanded);

        if (expanded) {
          content.classList.add('hidden');
          actions.classList.add('hidden');
          header.classList.add('rounded-b-md');

          upArrow.classList.add('hidden');
          downArrow.classList.remove('hidden');

          parent.dataset.expanded = '';
        } else {
          content.classList.remove('hidden');
          actions.classList.remove('hidden');
          header.classList.remove('rounded-b-md');

          upArrow.classList.remove('hidden');
          downArrow.classList.add('hidden');

          parent.dataset.expanded = true;
        }
      });
    });
  }
});
